import { render, staticRenderFns } from "./BoxPlanEditor.vue?vue&type=template&id=5f4766cc&scoped=true&"
import script from "./BoxPlanEditor.vue?vue&type=script&lang=js&"
export * from "./BoxPlanEditor.vue?vue&type=script&lang=js&"
import style0 from "./BoxPlanEditor.vue?vue&type=style&index=0&id=5f4766cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4766cc",
  null
  
)

export default component.exports